import { Injectable, EventEmitter } from '@angular/core';
import { ScrollControl } from '../../shared/stepper';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ZusammenfassungService {

  constructor(private scrollControl: ScrollControl) { }

  korrektur(event: any, selectors: string, korrekturEvent: EventEmitter<any>) {
    this.scrollControl.setScrollControl(selectors);
    korrekturEvent.emit(null);
    event.preventDefault();
  }

  strasseHausnummerStiegeStockTuer(strasse: string, hausnummer: string, stiege: string, stock: string, tuer: string): string {
    return (strasse || '') + (hausnummer ? ' ' + hausnummer : '') + (stiege ? ' / ' + stiege : '') + (stock ? ' / ' + stock : '') + (tuer ? ' / ' + tuer : '');
  }

  offeneSchaeden(firstSchadenZeitpunkt: any, secondSchadenZeitpunkt: any, thirdSchadenZeitpunkt: any): string {
    const schadenZeitpunkte = [firstSchadenZeitpunkt, secondSchadenZeitpunkt, thirdSchadenZeitpunkt]
      .filter(x => x).sort((x, y) => new Date(x).getTime() - new Date(y).getTime()).map(x => moment(x).format('DD/MM/YYYY'));
    return schadenZeitpunkte.join(' - ');
  }
}
